import { Controller } from "@hotwired/stimulus"

// Makes an entire row clickable by delegating clicks to a real inner <a>.
// Replaces the CSS "stretched link" pattern (absolute inset-0 inside the row),
// which is broken on iOS Safari because position:relative on <tr> does not
// establish a containing block — the absolute anchor escapes the row and ends
// up covering large parts of the viewport, hijacking unrelated clicks.
export default class extends Controller {
  static targets = ["link"]

  open(event) {
    if (event.target.closest("a, button, input, label, select, textarea")) return
    if (window.getSelection && window.getSelection().toString()) return
    if (!this.hasLinkTarget) return

    this.linkTarget.click()
  }
}
